/*
 * Author: Harper Yan
 * File Created: Sunday, 24-09-01 10:51 am
 * Last Modified: Tuesday, 25-06-24 02:15 pm, by Dw
 */

import type { NextPage } from 'next';
import type { ErrorProps } from 'next/error';
import * as Sentry from '@sentry/nextjs';
import { Box, Button, Typography } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import { pageRequestFailureCounter } from '@web/utils/metrics/index';
import AppContainer from '@/components/AppContainer';
interface CustomErrorProps extends ErrorProps {
  locale?: string;
}
const CustomErrorComponent: NextPage<CustomErrorProps> = props => {
  // return <Error statusCode={props.statusCode} />;

  return <AppContainer hideBreadcrumb hideMenu data-sentry-element="AppContainer" data-sentry-component="CustomErrorComponent" data-sentry-source-file="_error.page.tsx">
      <Box sx={{
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center'
    }} data-sentry-element="Box" data-sentry-source-file="_error.page.tsx">
        <Icon name="IllusErrorFlag" sx={{
        width: '70px',
        height: '70px',
        mt: '160px'
      }} data-sentry-element="Icon" data-sentry-source-file="_error.page.tsx" />
        <Typography sx={{
        fontSize: '12px',
        fontWeight: 500,
        color: '#707A8A',
        mt: '16px'
      }} data-sentry-element="Typography" data-sentry-source-file="_error.page.tsx">
          {props.title}
        </Typography>
        <Button onClick={() => {
        window.history.back();
      }} size="small" sx={{
        minWidth: '160px',
        p: '8px 12px',
        mt: '40px',
        fontSize: '14px'
      }} data-sentry-element="Button" data-sentry-source-file="_error.page.tsx">
          {props.locale === 'zh' ? '返回' : 'Back'}
        </Button>
      </Box>
    </AppContainer>;
};
CustomErrorComponent.getInitialProps = async contextData => {
  // In case this is running in a serverless function, await this in order to give Sentry
  // time to send the error before the lambda exits
  await Sentry.captureUnderscoreErrorException(contextData);

  // This will contain the status code of the response
  // return Error.getInitialProps(contextData);
  const {
    res,
    err,
    req,
    locale,
    pathname
  } = contextData;
  const lang = locale === 'zh' ? 'zh' : 'en';
  const errMessage = {
    zh: {
      404: '页面不存在',
      500: '服务器出错了'
    },
    en: {
      404: 'Page not found',
      500: 'Server error'
    }
  };
  const statusCode = res?.statusCode === 404 || err?.statusCode === 404 ? 404 : 500;
  const title = errMessage[lang][statusCode];
  pageRequestFailureCounter.add(1, {
    statusCode: err?.statusCode ?? res?.statusCode,
    path: req?.url,
    message: err?.message || 'Unknown error'
  });
  return {
    statusCode,
    title,
    locale
  };
};
export default CustomErrorComponent;